module.exports = __webpack_public_path__ + "static/media/HCMM695.3a57e260.jpg";